import { render, staticRenderFns } from "./auth-header.vue?vue&type=template&id=60fef272&scoped=true"
import script from "./auth-header.vue?vue&type=script&lang=ts"
export * from "./auth-header.vue?vue&type=script&lang=ts"
import style0 from "./auth-header.vue?vue&type=style&index=0&id=60fef272&prod&lang=scss&scoped=true"
import style1 from "./auth-header.vue?vue&type=style&index=1&id=60fef272&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fef272",
  null
  
)

export default component.exports